/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Push_UnavailableInputs */

const en_error_push_unavailable = /** @type {(inputs: Error_Push_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications on devices are off in this environment.`)
};

/**
* | output |
* | --- |
* | "Notifications on devices are off in this environment." |
*
* @param {Error_Push_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_push_unavailable = /** @type {((inputs?: Error_Push_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Push_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_push_unavailable(inputs)
});